module.exports = __webpack_public_path__ + "static/media/Cynthia.d80bcc5f.jpg";